import { message, Modal, Upload as UploadAntd } from "antd";
import React, { useState, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { uploadFile } from "react-s3";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import apiPath from "../constants/apiPath";

const s3Config = {
  region: process.env.REACT_APP_region,
  credentials: {
    accessKeyId: process.env.REACT_APP_aws_access_key,
    secretAccessKey:process.env.REACT_APP_aws_secret_key,
  },
  endpoint: "https://dunnnit.s3.me-central-1.amazonaws.com/",
  forcePathStyle: true,
};

const s3Client = new S3Client(s3Config);

const MultipleImageUpload = ({
  data,
  fileType,
  imageType,
  btnName,
  onDelete,
  onChange,
  maxCount = 8,
}) => {
  const supportedImageExtensions = [
    ".png",
    ".jpg",
    ".jpeg",
    ".avif",
    ".webp",
    ".gif",
  ];
  const supportedVideoExtensions = [".mp4", ".ogg", ".webm", ".mpeg"];
  const [fileList, setFileList] = useState([]);

  const beforeUpload = (file) => {
    if (fileType.includes(file.type)) {
    } else {
      message.error("File format is not correct");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;

    if (!isLt2M) {
      message.error(`Image must be smaller than 5 MB!`);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (!data) return;
    const multipleFileList = data.map((url, index) => ({
      uid: `${index + 1}`,
      name: url,
      status: "done",
      url: url,
    }));
    setFileList(multipleFileList);
  }, [data]);

  const uploadFileToS3 = async (file, bucketName) => {
        const key = "dunnnit/" + imageType + "/" + file.name;

    const apiUrl = `${apiPath.baseURL}/common/image-upload`;
    const formData = new FormData();
    formData.append("image", file);
    formData.append("type", bucketName);
    formData.append("key", key);

 
    try {
      const upload = await fetch(apiUrl, {
      method: "POST",
      body: formData,
    });
      const data = await upload.json();
      console.log(data,"data");
      return data.data;
    } catch (err) {
      throw err;
    }
  };

  const handleImgChange = async (event) => {
    const { file } = event;

    // setLoading(true);
    try {
      const data = await uploadFileToS3(file, "dunnnit");
      const fileData = {
        uid: file?.uid,
        name: file?.name,
        status: "done",
        url: data.upload,
        thumbUrl: data.upload,
      };
      console.log(data, "data");
      setFileList([...fileList, fileData]);
      if (onChange) {
        onChange([...fileList, fileData]);
      }

      //   setFile([fileData]);
      console.log(data);
    } catch (err) {
      console.error(err);
    }
  };

  const uploadButton = (
    <div>
      {" "}
      <PlusOutlined /> <div style={{ marginTop: 8 }}>Upload {btnName}</div>{" "}
    </div>
  );

  const handleRemove = (file) => {
    console.log(fileList, file);
    const newFile = fileList.filter((item) => item.uid != file.uid);
    setFileList(newFile);
    if (onChange) {
      onChange([...newFile]);
    }
    // onDelete(file.url)
  };

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewVideo, setPreviewVideo] = useState(null);

  const handleCancel = () => {
    setPreviewVisible(false);
    setPreviewVideo();
    setPreviewImage();
  };
  const handlePreview = async (file) => {
    console.log(file, "file");
    let video = supportedVideoExtensions.some((ext) =>
      file?.url?.toLowerCase().endsWith(ext)
    );
    console.log(video, "video");
    if (video) {
      setPreviewVideo(file?.url || file?.thumbUrl);
    } else {
      setPreviewImage(file.url || file.thumbUrl);
    }
    setPreviewVisible(true);
  };

  return (
    <>
      <UploadAntd
        listType="picture-card"
        onRemove={handleRemove}
        onPreview={handlePreview}
        maxCount={maxCount}
        // beforeUpload={beforeUpload}
        fileList={fileList}
        //onChange={handleChange}
        customRequest={handleImgChange}
      >
        {fileList.length >= maxCount ? null : uploadButton}
      </UploadAntd>
      <Modal
        bodyStyle={{
          padding: "0px !important",
          width: "auto !important",
          background: "black",
        }}
        // style={{ padding: "0px !important", background: "black" }}
        open={previewVisible}
        title={""}
        footer={null}
        onCancel={handleCancel}
      >
        {previewVideo ? (
          <video controls src={previewVideo} />
        ) : (
          <img alt="example" style={{ minWidth: "100%" }} src={previewImage} />
        )}
      </Modal>
    </>
  );
};

export default MultipleImageUpload;
